import React, { useEffect } from "react";
import Routes from "./Routes/index";

// Import Scss
import "./assets/scss/theme.scss";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import withRouter from "./components/Common/withRouter";
import { changeIsIframePage, changeIsModalPage } from "./store/actions";

function App(props) {
  const { Layout, profile } = useSelector((state) => ({
    Layout: state.Layout,
    profile: state.login.profile,
  }));
  const dispatch = useDispatch();  

  useEffect(() => {
    if(props.router.location.search.includes('iframe') || localStorage.getItem('render_in_iframe') || (window.self !== window.top)){
      localStorage.setItem('render_in_iframe', 'true');
      dispatch(changeIsIframePage(true));
    }
    if(props.router.location.search.includes('modal')){
      dispatch(changeIsModalPage(true));
    }
    if(profile){
      if (localStorage.getItem("UrlOriginNoAuth")) {
        window.open(window.location.origin + localStorage.getItem("UrlOriginNoAuth"), '_self');
        localStorage.removeItem("UrlOriginNoAuth");
      }
    }
  }, [profile]);

  return (
    <React.Fragment>
      <div className={`bg-painel ${Layout?.isModalPage ? "is-modal-page" : ""}`}>
        {Layout?.isLoading && (
          <div
            style={{
              backgroundColor: "#33333380",
              overflow: "hidden",
              display: "flex",
              top: 0,
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 9999,
            }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        )}
        <Routes />
      </div>
    </React.Fragment>
  );
}

export default withRouter(App);
